import { render, staticRenderFns } from "./persona-fisica.vue?vue&type=template&id=ad47c2f8"
import script from "./persona-fisica.vue?vue&type=script&lang=js"
export * from "./persona-fisica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports